import * as React from 'react';
import {useSelector} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import type {NutshellState} from '../../../store';

import * as selectors from '../forms-selectors';

import {formFieldFilterFunction} from './form-field-filter-function';

type Props = {
    numSubmissions: number;
    activeTab: string;
    activeFilters: FilterObject[];
};

export function FormStatusPrimaryText(props: Props) {
    const count = useSelector((state: NutshellState) =>
        selectors.getFormSubmissionsListCount(state)
    );
    const isFirstLoad = useSelector((state: NutshellState) =>
        selectors.getFormSubmissionsListIsFirstLoad(state)
    );

    const filters = props.activeFilters.filter((filter) =>
        // @ts-expect-error
        formFieldFilterFunction(Object.keys(filter)[0])
    );

    const additionalSubmissionsMessage = () =>
        ` from ${count} ${count === 1 ? 'person' : 'people'}`;

    // We'll conditionally show the person count alongside the submission count
    // because it can differ from the # submissions if someone submitted this
    // form multiple times. We show this when…
    //
    // 1) We're on the submission tab
    // 2) The number of submissions does not match the number of people who submitted
    // 3) There are no extra filters applied (which further confuses the counts)
    const shouldShowPersonCount = () => {
        return (
            props.activeTab === 'submissions' &&
            props.numSubmissions !== count &&
            !isFirstLoad &&
            filters.length === 0
        );
    };

    const primaryText = `${props.numSubmissions} ${
        props.numSubmissions === 1 ? 'submission' : 'submissions'
    } ${shouldShowPersonCount() ? additionalSubmissionsMessage() : ''}`;

    return <div>{primaryText}</div>;
}
